const initials = (name) =>
  String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('') || '?';

const sizes = {
  md: 'w-9 h-9 text-base',
  lg: 'w-10 h-10 text-base',
};

const Avatar = ({ name, size = 'md', className = '' }) => (
  <span
    aria-hidden="true"
    className={`inline-flex shrink-0 items-center justify-center rounded-full bg-primary-500 font-medium text-white ${sizes[size]} ${className}`}
  >
    {initials(name)}
  </span>
);

export default Avatar;
